<template>
  <div>
    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
             <span class="headline font-weight-bold">Let's collect some details on the Customer's Problem</span> 
             
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->

                 <v-text-field
                  outline  
                  v-if="dropdownList[0].isEnabled"
                  :rules="textInputRules"
                  :label="projecttitleLabelText"
                  v-model="projecttitle"
                  
                >
                 </v-text-field> 
                
                <v-textarea
                  outline    
                  v-if="dropdownList[1].isEnabled"
                  :rules="textInputRules"
                  :label="customerproblemdescriptionLabelText"
                  v-model="customerproblemdescription" 
                > </v-textarea>  

                <v-textarea
                  outline  
                  v-if="dropdownList[2].isEnabled"
                  :rules="textInputRules"
                  :label="whythisproblemLabelText"
                  v-model="whythisproblem"
                >
                
                <!-- :value="customerproblemdetail.textValue" --></v-textarea> 


   


  

 





            
                
                <!-- <v-tooltip bottom v-if="customerproblemdetail.componentid && customerproblemdetail.tooltip">
      <template v-slot:activator="{ on }">
                            <v-btn flat icon color="grey" v-on="on">
              <v-icon>help</v-icon>
            </v-btn>
             </template>
      <span>Tooltip</span>
    </v-tooltip> --> 
                  <!-- </v-layout> -->
                <!-- :prepend-icon="customerproblemdetail.prependicon" -->
                <!-- </span> -->
                <!-- <v-text-field
                  outline
                  v-model="title"
                  v-if="includeWhyTheProblemIsImportantToTheCustomer"
                  label="Why is the problem important to the customer?"
                  prepend-icon="folder"
                ></v-text-field> -->

                

                <v-spacer></v-spacer>

                <v-menu offset-y v-if="doWeHaveAdditionalDetailsToAdd"> 
                  <!-- v-if="doWeHaveAdditionalDetailsToAdd" -->
                  
                  <template v-slot:activator="{ on }"> 
                    <v-btn flat  color="primary" dark v-on="on">Add more details</v-btn> 
                  </template>
                  
                  <v-list>
                    <v-list-tile v-for="(dropdownListElement, index) in remainingDetailsToBeAdded" :key="index" @click="dropdownListElement.isEnabled = true">
                      <v-list-tile-title>{{ dropdownListElement.titleText }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>

                <v-spacer></v-spacer>
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
                <!-- <v-btn @click="submit" class="primary mx-2 mt-3" :loading="loading">Proceed to User pain points</v-btn> -->
                <!-- <v-btn flat to="/addpainpoints" color="primary" class="mx-2 mt-3" :loading="loading">Proceed to User pain points</v-btn>  -->
                <v-btn flat to="/addpainpoints" color="primary" class="mx-2 mt-3" :loading="loading">Go Next</v-btn> 
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {},
  data() {
    return { 
      doWe: false,
      projecttitle:'My ToDo list',
      projecttitleEnabled: true,
      projecttitleLabelText: 'Provide a title for your project',
      customerproblemdescription:'The customer tends to have too many tasks to manage. There is no system in place to help them manage their tasks efficiently, at the moment.', 
      customerproblemdescriptionEnabled: true,
      customerproblemdescriptionLabelText: 'Describe the problem that the customer is facing',
      whythisproblem: 'If the customers cannot reach a certain level of productivity, they will be unable to meet their target goals for the quater and therefore will be more likely to create poor quality products (or lose their paying clients).',
      whythisproblemEnabled: true,
      whythisproblemLabelText: 'Why is the problem important to the customer?',
      targetagerange: 'between 18 and 34 years',
      targetagerangeEnabled: true,
      targetagerangeLabelText: 'What is the age range of the target audience?',
      problemdomain: 'Both Enterprise and Consumer',      
      problemdomainEnabled: true,
      problemdomainLabelText: 'Which domain does this Problem fall in?',
      additionaldetailforproblem: 'The end users tend to work collaboratively on many of the tasks.',
      additionaldetailforproblemEnabled: true,
      additionaldetailforproblemLabelText: 'Is there any other detail you would like to add?',
      locationofuser: 'Urban',
      locationofuserEnabled: true,
      locationofuserLabelText: 'What type of environment do the users live in?',
      locationofsolutionusage: 'During work.',
      locationofsolutionusageEnabled: true,
      locationofsolutionusageLabelText: 'Where do the users face these issues?',
      metrictitle: 'Daily task completion target',
      metricproblemspaceEnabled: true,
      metricproblemspaceLabelText: 'Provide one metric which will help track the customer problem:',
      userpersonalink:'https:://www.duckduckgo.com', 
      userpersonalinkLabelText: 'Please provide a link to the User\'s Persona:',
      dropdownList: [
        {component: 'projecttitle', isEnabled: true, titleText: 'Provide a title for your project'},
        {component: 'customerproblemdescription', isEnabled: true, titleText: 'Describe the problem that the customer is facing'},
        {component: 'whythisproblem', isEnabled: true, titleText: 'Why is the problem important to the customer?'},
        {component: 'targetagerange', isEnabled: true, titleText: 'What is the age range of the target audience?'},
        {component: 'problemdomain', isEnabled: true, titleText: 'Which domain does this Problem fall in?'},
        {component: 'additionaldetailforproblem', isEnabled: true, titleText: 'Is there any other detail you would like to add?'},
        {component: 'locationofuser', isEnabled: true, titleText: 'What type of environment do the users live in?'},
        {component: 'locationofsolutionusage', isEnabled: true, titleText: 'Where do the users face these issues?'},
        {component: 'metricproblemspace', isEnabled: true, titleText: 'Provide one metric which will help track the customer problem as a solution is introduced:'},
        {component: 'userpersonalink', isEnabled: true, titleText: 'lease provide a link to the User\'s Persona:'}

      ],
      customerproblemdetails: [
        { title: 'Add Project Title', storagecode: 'projecttitle', labeltext: 'Provide a title for your project', type: 'title', textValue: 'My Venture v2', prependicon: 'edit', componentid: true, tooltip: true },
        { title: 'Add Details of the customer problem', storagecode: 'customerproblemdescription', labeltext: 'Describe the problem that the customer is facing', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'edit', componentid: true, tooltip: true },
        { title: 'Add Importance of the problem to the customer', storagecode: 'whythisproblem', labeltext: 'Why is the problem important to the customer?', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'folder', componentid: false, tooltip: false },
        { title: 'Add Age range', storagecode: 'targetagerange', labeltext: 'What is the age range of the target audience?', type: 'agerange', prependicon: 'edit', componentid: false, tooltip: true },
        { title: 'Add the problem domain', storagecode: 'problemdomain', labeltext: 'Which domain does this Problem fall in?', type: 'select', textValue: 'Not Sure', prependicon: 'edit', componentid: false, tooltip: true },
        { title: 'Add additional misc. details', storagecode: 'additionaldetailforproblem', labeltext: 'Is there any other detail you would like to add?', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'edit', componentid: false, tooltip: true }
      ],
      slider: 45,
        volume: 10,
        age: [18, 34],
      items: ['Enterprise', 'Consumer', 'Both Enterprise and Consumer', 'Not Sure'],
      userlocations: ['Urban', 'Rural'],
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      loading: false
    }
  },
  methods: {
    submit(){
      //console.log(this.dropdownList[1].isEnabled)
      
 if(this.$refs.form.validate()) {
        //console.log("Attempt to submit")
        this.loading = true;
        //  const project = {

        //   projecttitle: this.projecttitle,
        //   customerproblemdescription: this.customerproblemdescription,
        //   whythisproblem: this.whythisproblem,
        //   targetagerange: this.targetagerange,
        //   problemdomain: this.problemdomain,
        //   additionaldetailforproblem: this.additionaldetailforproblem,
        //   locationofuser: this.locationofuser,
        //   locationofsolutionusage: this.locationofsolutionusage
        // }

        // // db.collection('projects').add(project).then(function(docRef) {
        // //         console.log("Document written with ID: ", docRef.id);
        // //         this.loading = false;


        // //     })
        // //     .catch(function(error) {
        // //         console.error("Error adding document: ", error);
        // //     });

        //    db.collection('projects').add(project).then(() => {
        //   //console.log("added to db!", docRef.id)
        //   this.loading = false;
        //   this.$router.push('addstoriespainpoints')
        // })
      




            const project = {
          projecttitle: this.projecttitle,
          customerproblemdescription: this.customerproblemdescription,
          whythisproblem: this.whythisproblem,
          targetagerange: this.targetagerange,
          problemdomain: this.problemdomain,
          additionaldetailforproblem: this.additionaldetailforproblem,
          locationofuser: this.locationofuser,
          locationofsolutionusage: this.locationofsolutionusage
            }
 

            db.collection('projects').doc(this.getProjectID()).update(project).then(() => {
                    //console.log("added to db!", this.getProjectID())
                    this.loading = false;
                    this.dialog = false;
                    this.$router.push('addpainpoints')
                    ///this.$emit('firstprefdetailsconfirmed')
                });



          const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Problem space'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });


        }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    remainingDetailsToBeAdded(){
      return this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
    },
    doWeHaveAdditionalDetailsToAdd(){
      this.doWe = this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
  
      //console.log(this.doWe) 
      if (this.doWe.length == 0)
      {
        return false
      }else{
        return true
      }

      //this.doWe = doWe

      //return this.doWe
    }
  }
};
</script>

<style>
</style>
